import React, { useState, useRef, useEffect } from 'react'
import { MD5 } from '../../../services/others/helpers-md5'
import { ApiRequest } from '../../../services/api/api'

const CommonFormCustomItem = ({ value, onChange }: any) => {
  const [productName, setProductName] = useState('')
  const [productDesc, setProductDesc] = useState('')
  
  const [isLoading, setIsLoading] = useState(false)
  const [hasFetched, setHasFetched] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState({ left: '50%', transform: 'translateX(-50%)' })
  const tooltipRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  
  const handleMouseEnter = async () => {
    setShowTooltip(true)
    
    // 只在第一次 hover 时调用 API
    if (!hasFetched && value) {
      setIsLoading(true)
      try {
        const product = await ApiRequest({
          url: "BaseProduct/GetBaseProductById?id=" + value +"&inclInactive=1",
          method: "get",
          isShowSpinner: false,
        })
        setProductName(product.data.data.baseProductName || value)
        setProductDesc(product.data.data.description || "")
      } catch (error) {
        setProductName(value)
      } finally {
        setIsLoading(false)
        setHasFetched(true)
      }
    }
  }
  
  const handleMouseLeave = () => {
    setShowTooltip(false)
  }

  useEffect(() => {
    if (showTooltip && tooltipRef.current && containerRef.current) {
      const tooltip = tooltipRef.current
      const container = containerRef.current
      const tooltipRect = tooltip.getBoundingClientRect()
      const containerRect = container.getBoundingClientRect()
      
      setTooltipPosition({ left: '0', transform: 'translateX(0)' })
    }
  }, [showTooltip, productName, isLoading])

  return (
    <div 
      ref={containerRef}
      style={{display: 'flex', position: 'relative'}}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        style={{
          width: '1.2rem',
          height: '1.2rem',
          borderRadius: '3rem',
          backgroundColor: '#' + Math.floor(parseFloat('0.' + (value ? parseInt(MD5(value).replace(/[a-z]/g, '')) : '000')) * 16777215).toString(16),
          margin: '0 auto',
        }}
      >
      </div>
      <div><b>{value}</b></div>
      
      {showTooltip && (
        <div
          ref={tooltipRef}
          style={{
            position: 'absolute',
            bottom: '100%',
            ...tooltipPosition,
            backgroundColor: '#1890ff',
            color: '#fff',
            padding: '0.75rem 1rem',
            borderRadius: '0.5rem',
            whiteSpace: 'nowrap',
            fontSize: '1rem',
            fontWeight: 'bold',
            marginBottom: '0.5rem',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            border: '2px solid #0050b3',
          }}
        >
          {isLoading ? (
            <span>⏳ Loading...</span>
          ) : (
            <div>
              {productName && <div>{productName}</div>}
              {productDesc && <div>{productDesc}</div>}
            </div>
          )}
          {/* 小箭头 */}
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: tooltipPosition.left === '50%' ? '50%' : (tooltipPosition.left === '0' ? '1rem' : 'auto'),
              right: tooltipPosition.left === 'auto' ? '1rem' : 'auto',
              transform: tooltipPosition.left === '50%' ? 'translateX(-50%)' : 'none',
              width: 0,
              height: 0,
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderTop: '8px solid #0050b3',
            }}
          />
        </div>
      )}
    </div>
  )
}

export default CommonFormCustomItem